import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import { SCREEN_ID_LOGOUT } from 'client/constants/screenIds';

import SrLogo from 'client/components/SrLogo';

import log from 'client/lib/log';
import AuthActions from 'client/actions/Auth';
import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

@withTransitionHook
@withScreenId(SCREEN_ID_LOGOUT)
@withScrollToTop
@branch({
  currentUserRoles: ['currentUser', 'roles'],
  currentUtilityUser: ['utilityUser'],
})
class LogoutPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Logout | Sunroom Rentals',
    section: 'Logout',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { dispatch } = this.props;
    const locationQuery = queryString.parse(location.search);
    const redirectUrl = locationQuery.next || '/login';

    dispatch(AuthActions.logout)
      .then(() => {
        global.location.href = redirectUrl;
      })
      .catch((error) => log.error(error));
  }

  render() {
    return (
      <div className="page-logout">
        <div className="loginContainer">
          <SrLogo />
          <div className="loading-gif" />
        </div>
      </div>
    );
  }
}

LogoutPage.displayName = 'LogoutPage';

export default LogoutPage;
